import script from "./test.vue?vue&type=script&setup=true&lang=ts"
export * from "./test.vue?vue&type=script&setup=true&lang=ts"

import "./test.vue?vue&type=style&index=0&id=aab0bff4&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab0bff4"]])

export default __exports__